import template from './employee-dropdown.html';
import controller from './employee-dropdown.controller';

let employeeDropdownComponent = {
  restrict: 'E',
  bindings: {
    selectedEmployee: '=ngModel',
    employees: '<',
    onSelect: '&?',
    required: '<?',
    placeholder: '@?',
    disabled: '<?'
  },
  template,
  controller
};

export default employeeDropdownComponent;



// WEBPACK FOOTER //
// ./client/common/directives/employee-dropdown/employee-dropdown.component.js